export const FLIGHT_SEQUENCE_OUTBOUND = 1;
export const FLIGHT_SEQUENCE_RETURN = 2;
